require('react').PropTypes = require('prop-types')
